import React from "react";
import styled from "styled-components";
import PageBuilder from "../../components/PageBuilder/PageBuilder";
import { useSanityContent } from "../../hooks/useSanityContent";
import { PAGE_QUERY } from "../../sanity/queries";

const BookASpaceContainer = styled.div`
  min-height: 100vh;
  padding-top: 90px;
  background: #101015;
  @media (max-width: 768px) { padding-top: 100px; }
`;

const fallbackSections = [{ _type: "bookSpaceForm", title: "Book a Space" }];

export default function BookASpace() {
  const { data } = useSanityContent(PAGE_QUERY("book-a-space"), { sections: fallbackSections });
  return (
    <BookASpaceContainer>
      <PageBuilder sections={data.sections} />
    </BookASpaceContainer>
  );
}
